export const activeReport = () => JSON.parse(localStorage.getItem('selectedReport'));

export default activeReport;
